import { useState, useEffect } from 'react';

import './App.css';

import Contenido from './components/Contenido';
import Notas from './components/Notas';

import Logo from './logo.svg';

function App() {

    const [newText, setNewText] = useState('');
    const [showSidebar, setShowSidebar] = useState(false);
    const [openSibedar, setOpenSidebar] = useState(false);
    const [hashtagRecient, setHashtagRecient] = useState('');
    
    useEffect( () => {
        if(window.innerWidth >= 750){
            setShowSidebar(true);
            setOpenSidebar(true)
        }
    }, []);

    return (
        <>
            {/* <Header  user={user} /> */}
            
            <div className="title-content">
                {/* <h1 className="title" >Space<span>Gram</span></h1> */}
                <img src={Logo} alt=""/>
                <p>Planifica, diseña y organiza tus textos para Instagram</p>
            </div>

            <div className="content-app" >
                <div className="content--form">
                    <Contenido
                        newText={newText}
                        setNewText={setNewText}
                        openSibedar={openSibedar}
                        setOpenSidebar={setOpenSidebar}
                        setHashtagRecient={setHashtagRecient}
                    />
                </div>
                <div className={showSidebar ? 'content-proyect' : 'fixed-mobile'} style={{marginRight: openSibedar ? '0%' : '-100%'  }} >
                    <Notas
                        setNewText={setNewText}
                        openSibedar={openSibedar}
                        setOpenSidebar={setOpenSidebar}
                        hashtagRecient={hashtagRecient}
                        setHashtagRecient={setHashtagRecient}
                    />
                </div>
            </div>

            <footer>
                
                <p>Copyright &copy; {new Date().getFullYear()} | Spacegram by Convierte Más </p>
                <a href="https://triunfagram.com/politica-de-privacidad/" target="_blank" >Política de privacidad</a>
            </footer>
        </>
    );
}

export default App;
